import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Grid, Paper, Avatar } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import CodeIcon from '@mui/icons-material/Code';
import WorkIcon from '@mui/icons-material/Work';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InnovationIcon from '@mui/icons-material/EmojiObjects';

const AboutContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#f5f5f5',
}));

const StyledItem = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(2),
  textAlign: 'center',
  color: 'black',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '20px',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: 'white',
  width: theme.spacing(7),
  height: theme.spacing(7),
  margin: theme.spacing(1),
}));

const Title = styled(Typography)({
  fontWeight: 'bold',
  margin: '8px 0',
});

const Description = styled(Typography)({
  fontSize: '1rem',
});

const AboutSection = () => {
  return (
    <AboutContainer id="aboutSection">
      <Grid container spacing={3} justifyContent="center">
        {[
          {
            icon: <SchoolIcon style={{ fontSize: '3rem', color: '#333' }} />,
            title: 'Academic Excellence',
            description: 'Top percentage in schooling and a dual degree from IIT (BHU).',
          },
          {
            icon: <CodeIcon style={{ fontSize: '3rem', color: '#333' }} />,
            title: 'Programming Mastery',
            description: 'Skilled in C/C++, JavaScript, Python, React.js, and Django.',
          },
          {
            icon: <WorkIcon style={{ fontSize: '3rem', color: '#333' }} />,
            title: 'Professional Experience',
            description: 'Data Scientist at Jio and SDE at Fenmo with impactful contributions.',
          },
          {
            icon: <EmojiEventsIcon style={{ fontSize: '3rem', color: '#333' }} />,
            title: 'Competitive Achievements',
            description: 'Notable ranks in coding competitions and open-source contributions.',
          },
          {
            icon: <InnovationIcon style={{ fontSize: '3rem', color: '#333' }} />,
            title: 'Innovative Projects',
            description: 'Developed GitHub Visualizer and Neural Machine Translation System.',
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <StyledItem>
              <StyledAvatar>{item.icon}</StyledAvatar>
              <Title variant="h6">
                {item.title}
              </Title>
              <Description variant="body2">
                {item.description}
              </Description>
            </StyledItem>
          </Grid>
        ))}
      </Grid>
    </AboutContainer>
  );
};

export default AboutSection;